import React, { useState, useEffect, useContext } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import saveClient from "../functions/saveClientRegister";

import { SessionContext } from "../context/session-context";

const useStyles = makeStyles({
    root: {
        paddingLeft:20,
    },
    textField:{
        width:'90%',
        maxWidth: 500,
    },
    clientButton:{
        width: 160,
        padding: 5,
        marginRight:20,
    }
});

export default function ClientForm(props) {
    const classes = useStyles();
    const [sState, sDispatch] = useContext(SessionContext);
    const client = props.client || {};
    const [companyName, setCompanyName] = useState('');
    const [companyID, setCompanyID] = useState(0);
    const [findID, setFindID] = useState(0);
    const [zohoID, setZohoID] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [county, setCounty] = useState('');
    const [country, setCountry] = useState('');
    const [postcode, setPostcode] = useState('');
    const [telephone, setTelephone] = useState('');
    const [status, setStatus] = useState('active');
    const [pricingModelID, setPricingModelID] = useState(1);
    const [creditLimit, setCreditLimit] = useState(250);
    const [companyType, setCompanyType] = useState('standard');
    const [registeredDate, setRegisteredDate] = useState('');

    const [username, setUsername] = useState('');
    const [companyid, setCompanyid] = useState(0);
    const [userid, setUserid] = useState(0);
    const [email, setEmail] = useState('');
    const [utype, setUtype] = useState('user');
    const [uStatus, setuStatus] = useState('active');


    useEffect(() => {
        const pricingModel = client.pricemodelid ?? 1;
        const creditLimitValue = client.creditlimit != null ? parseInt(client.creditlimit, 10) : 250;

        setCompanyName(client.companyname || '');
        setCompanyID(client.companyid || 0);
        setFindID(client.findid || 0);
        setAddress1(client.address1 || '');
        setAddress2(client.address2 || '');
        setCity(client.city || '');
        setCounty(client.county || '');
        setCountry(client.country || '');
        setPostcode(client.postcode || '');
        setTelephone(client.telephone || '');
        setStatus(client.status || 'active');
        setPricingModelID(pricingModel);
        setCreditLimit(Number.isFinite(creditLimitValue) ? creditLimitValue : 250);
        setCompanyType(client.ctype || 'standard');
        setUsername(client.username || '');
        setEmail(client.email || '');
        setUtype(client.utype || 'user');
        setuStatus(client.ustatus || 'active');
        setRegisteredDate(client.created || '');

    },[client])

    const handleClientApproval = () => {
        clientUpdate('active');
    }

    const handleClientRejection = () => {
        clientUpdate('rejected');
    }

    const clientUpdate = (status) => {
        
        const client = {
            companyID:companyID,
            companyName:companyName,
            address1:address1,
            address2:address2,
            city:city,
            county:county,
            country:country,
            postcode:postcode,
            telephone:telephone,
            status:status,
            pricingModelID:pricingModelID,
            creditLimit:creditLimit,
            companyType:companyType,
            findID:findID,
            zohoID:zohoID
        }

        saveClient(client, sDispatch);
        props.updated();

    };

    return (
        <div className={classes.root}>
            <Grid container>
                <Grid item xs={12}>
                    <TextField className={classes.textField} name="companyName" label="Company Name" size="small" margin="dense" variant="outlined" value={companyName} onChange={e => setCompanyName(e.target.value)}/>
                </Grid>
                <Grid item xs={8}>
                    <TextField className={classes.textField} name="address1" label="Address 1" size="small" margin="dense" variant="outlined" value={address1} onChange={e => setAddress1(e.target.value)}/> 
                    <TextField className={classes.textField} name="address2" label="Address 2" size="small" margin="dense" variant="outlined" value={address2} onChange={e => setAddress2(e.target.value)}/> 
                    <TextField className={classes.textField} name="city" label="City" size="small" margin="dense" variant="outlined" value={city} onChange={e => setCity(e.target.value)}/>
                    <TextField className={classes.textField} name="county" label="County" size="small" margin="dense" variant="outlined" value={county} onChange={e => setCounty(e.target.value)}/>
                    <TextField className={classes.textField} name="country" label="Country" size="small" margin="dense" variant="outlined" value={country} onChange={e => setCountry(e.target.value)}/>
                    <TextField className={classes.textField} name="postcode" label="Postcode" size="small" margin="dense" variant="outlined" value={postcode} onChange={e => setPostcode(e.target.value)}/>
                    <TextField className={classes.textField} name="telephone" label="Telephone" size="small" margin="dense" variant="outlined" value={telephone} onChange={e => setTelephone(e.target.value)}/>
                    <TextField className={classes.textField} name="pricingModel" label="Pricing Model" size="small" margin="dense" variant="outlined" value={pricingModelID} onChange={e => setPricingModelID(e.target.value)} select>
                        <MenuItem value={1}>Default</MenuItem>
                    </TextField>
                    <TextField className={classes.textField} name="companyType" label="Company Type" size="small" margin="dense" variant="outlined" value={companyType} onChange={e => setCompanyType(e.target.value)} select>
                        <MenuItem value={'standard'}>Standard</MenuItem>
                        <MenuItem value={'gia'}>GIA</MenuItem>
                    </TextField>
                    <TextField className={classes.textField} name="creditLimit" label="Credit Limit" size="small" margin="dense" variant="outlined" value={creditLimit} onChange={e => setCreditLimit(e.target.value)}/>
                    <TextField className={classes.textField} name="registeredDate" label="Registration Date" size="small" margin="dense" variant="outlined" value={registeredDate} readOnly />
                </Grid>
                <Grid item xs={4}>
                    <TextField className={classes.textField} name="username" label="Username" size="small" margin="dense" variant="outlined" value={username} onChange={e => setUsername(e.target.value)}/> 
                    <TextField className={classes.textField} name="email" label="Email" size="small" margin="dense" variant="outlined" value={email} onChange={e => setEmail(e.target.value)}/>
                    <TextField className={classes.textField} name="utype" label="User Type" size="small" margin="dense" variant="outlined" value={utype} onChange={e => setUtype(e.target.value)} select>
                        <MenuItem value={'user'}>User</MenuItem>
                        <MenuItem value={'manager'}>Manager</MenuItem>
                        <MenuItem value={'admin'}>Admin (Mapdata only)</MenuItem>
                    </TextField> 
                    <TextField className={classes.textField} name="uStatus" label="Status" size="small" margin="dense" variant="outlined" value={uStatus} onChange={e => setuStatus(e.target.value)} select>
                        <MenuItem value={'active'}>Active</MenuItem>
                        <MenuItem value={'disabled'}>Disabled</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <Button className={classes.clientButton} variant="contained" onClick={handleClientApproval} >
                        <Box fontWeight="fontWeightRegular" fontSize={12} >Aprove</Box>
                    </Button>
                    <Button className={classes.clientButton} variant="contained" onClick={handleClientRejection} >
                        <Box fontWeight="fontWeightRegular" fontSize={12} >Reject</Box>
                    </Button>
                </Grid>
            </Grid>
        </div>
    )
  };
